<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="8">
        <h3>Default Signatories Form</h3>
        <el-form ref="form" :model="form" :key="key" label-width="120px" style="margin-top: 20px">
          <el-form-item label="Type" required>
            <el-select v-model="form.type" filterable clearable placeholder="Please select benefits">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="Personnel" required>
            <el-select v-model="form.personnel_id" filterable clearable placeholder="Please select personnel">
              <el-option
                v-for="item in personnel"
                :key="item.id"
                :label="item.fullname"
                :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="Designation" required>
            <el-input
              v-model="form.label"
              :rows="2"
              type="textarea"
              placeholder="Please input label " />
          </el-form-item>
          <el-form-item label="Status" required>
            <el-switch v-model="form.status"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveData">Create</el-button>
            <el-button @click="refresh">Refresh</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :md="16">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>List Of Default Signatories</span>
            <!--el-button style="float: right; padding: 3px 0" type="text">Operation button</el--->
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="Personnel name">
              <template slot-scope="scope">
                {{ scope.row.personnel.fullname }}
              </template>
            </el-table-column>
            <el-table-column
              label="Designation">
              <template slot-scope="scope">
                {{ scope.row.label }}
              </template>
            </el-table-column>
            <el-table-column
              label="Type">
              <template slot-scope="scope">
                {{ searchType(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="Status">
              <template slot-scope="scope">
                {{ scope.row.status === 1 ? 'Active' : 'In active' }}
              </template>
            </el-table-column>
            <el-table-column label="Operation" align="center">
              <template slot-scope="scope">
                <el-button type="warning" size="small" @click="edit(scope.row)"><i class="fas fa-edit"/></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { NotifyError, NotifySuccess } from '../../../helper/Helper'
import { Signatories } from '../../../api/payroll/payroll_signatory'

export default {
  name: 'Signatory',
  data() {
    return {
      form: {
        'did': null,
        'type': null,
        'personnel_id': null,
        'status': false,
        'label': null
      },
      loading: false,
      tableData: [],
      personnel: {},
      type: ['Cash', 'Accounting', 'RSPPRO', 'University President'],
      options: [
        {
          'value': 1,
          'label': 'Cash'
        },
        {
          'value': 2,
          'label': 'Accounting'
        },
        {
          'value': 3,
          'label': 'RSPPRO'
        },
        {
          'value': 4,
          'label': 'University President'
        }
      ],
      key: 0
    }
  },
  created() {
    this.getAll()
    this.getPersonnelList()
  },
  methods: {
    searchType(id) {
      var m = this.options.find(o => o.value === id)
      return m.label
    },
    getAll() {
      this.loading = true
      this.refresh()
      Signatories({}, 'get', 'getSignatoriesList').then(res => {
        // console.log(res.data)
        this.tableData = res.data
        this.loading = false
      }).catch()
    },
    getPersonnelList() {
      Signatories({}, 'get', 'getPersonnelList').then(res => {
        this.personnel = res.data
      }).catch()
    },
    refresh() {
      this.form = {
        'did': null,
        'type': null,
        'personnel_id': null,
        'status': false,
        'label': null
      }
    },
    saveData() {
      if (this.form.status === true) {
        this.form.status = 1
      } else {
        this.form.status = 0
      }
      let action = 'saveDefaultSignature'
      if (this.form.did) {
        action = 'UpdateDefaultSignature'
      }
      Signatories(this.form, 'post', action).then(res => {
        if (res.data.success === false) {
          NotifyError(res.data.message)
        } else {
          NotifySuccess(res.data.message)
        }
        this.getAll()
      }).catch()
    },
    edit(row) {
      this.key++
      this.form.did = row.id
      this.form.type = row.type
      this.form.personnel_id = row.personnel_id
      this.form.status = row.status === 1
      this.form.label = row.label
    }
  }
}
</script>

<style scoped>

</style>
